import React from 'react';
import EditNote from '@mui/icons-material/EditNote';
import AddTimelineItemsButtons from 'domain/shared/timeline/person/AddTimelineItemsButtons';
import PersonTimeline from 'domain/shared/timeline/person';
import { useVendorId } from 'domain/finance/vendors/routes';
import { useVendorTimelineService } from 'domain/finance/vendors/useVendorService';
import useVendorNoteRegistry from './note/useVendorNoteRegistry';
import { VENDOR_TIMELINE_MESSAGE_CONTEXT } from './constants';

const VendorTimeline = () => {
  const vendorId = useVendorId();
  const { searchTimelineItems, createTimelineItem, getTimelinePageById } = useVendorTimelineService();

  const noteRegistry = useVendorNoteRegistry();

  const formConfig = {
    CreateVendorNoteForm: {
      icon: <EditNote />,
      text: 'New note',
    },
    default: {
      icon: <EditNote />,
      text: 'New entry',
    },
  };

  const TimelineItemInput = (props: any) => <AddTimelineItemsButtons {...props} registries={[noteRegistry]} />;

  return (
    <PersonTimeline
      entityId={vendorId}
      registries={[noteRegistry] as any}
      getTimelineItems={searchTimelineItems}
      createTimelineItem={createTimelineItem}
      getTimelinePageById={getTimelinePageById}
      messageContext={VENDOR_TIMELINE_MESSAGE_CONTEXT}
      AddTimelineItemInput={TimelineItemInput}
      formConfig={formConfig}
      noEntriesMessage="No entries in this vendor timeline yet."
    />
  );
};

export default VendorTimeline;
